export const UserApi = Symbol.for('UserApi');
